import React from 'react';
import { connect } from 'react-redux';
import {Container,Row,Col,Modal} from 'react-bootstrap';
import {FormDatosUsuario,FormCambiarPassword} from '../../_components/Perfil';
import * as serviceWorker from '../../serviceWorker';
import { alertActions, userActions } from '../../_actions';
import { userService } from '../../_services';
import { alertConfirm } from '../../_helpers';

class MisDatos extends React.Component {

    state={
        show:false,
        showTelegram:false,
        justRefresh:false,
        hasSuscripcionPush: false
    }

    componentDidMount(){      
        const deviceId = serviceWorker.getDeviceId();
        if(!!deviceId){
            const {user} = this.props;

            if(user && user.suscripciones){
                const thisDevSuscrip = user.suscripciones.find(it=>it.auth == deviceId);
                console.log('thisDevSuscrip',thisDevSuscrip);
                if(thisDevSuscrip){
                    this.setState({hasSuscripcionPush:true})
                }
            }
        }
    }

    handleClose = () => {
        this.setState({show: false,showTelegram:false});
    };

    desuscribir = (event) => {        
        userService.eliminarPushSuscripcion(serviceWorker.getDeviceId()).then((result)=>{
            this.setState({justRefresh: !this.state.justRefresh, hasSuscripcionPush:false});
        });

    }

    pedirSuscripcion = (event) => {
        // 1. Verificar que es un evento real de usuario
        if (!event?.isTrusted) {
            console.warn('⚠️ Evento no confiable - solicitando confirmación');
            if (!window.confirm('¿Estás seguro de que quieres activar las notificaciones?')) {
                return Promise.reject(new Error('Usuario canceló'));
            }
        }
        
        // 2. Verificar user activation
        if (!navigator.userActivation?.isActive) {
            console.warn('⚠️ User activation no detectada');
        }

        try {
            console.log('🔍 [1] Permiso INICIAL:', Notification.permission);

            // Verificar permiso actual - USAR SOLO ESTA VERIFICACIÓN
            if (Notification.permission === 'denied') {
                throw new Error('Los permisos de notificación fueron denegados. Debes habilitarlos manualmente en la configuración del navegador.');
            }

            if (Notification.permission === 'granted') {
                console.log('Permiso para notificaciones ya concedido');
                this.ejecutarSuscripcion();
                return;
            }

            if (Notification.permission === 'default') {
                console.log('🔍 [2] Solicitando permiso...');
                let permissionRequestTime = Date.now();
                 Notification.requestPermission().then((response) => {
                    let responseTime = Date.now();
                    

                    console.log('🔍 [3..] Respuesta de requestPermission:', response);
                    console.log('🔍 [3..] Permiso después de respuesta:', Notification.permission);
                    
                    if (response === 'granted') {
                        console.log('🔍 [4] Permiso concedido - procediendo con suscripción');
                        this.ejecutarSuscripcion();                      
                    } else {
                        const timeElapsed = responseTime - permissionRequestTime;
                        const isAutoResponse = timeElapsed < this.autoResponseTimeout;
                        if (isAutoResponse) {
                            if (/Android|iPhone|iPad/i.test(navigator.userAgent)) {
                                this.mostrarInstruccionesMovil();
                            }
                        }else{
                            console.log('🔍 [4] Permiso denegado en respuesta');
                            throw new Error('Permiso denegado por el usuario');
                        }
                        
                    }
                });
            }
            
        } catch (error) {
            console.error('Error en el proceso de suscripción:', error);
             if (/Android|iPhone|iPad/i.test(navigator.userAgent)) {
                this.mostrarInstruccionesMovil();
            }
        }     
    }

    // Función separada para la suscripción
    ejecutarSuscripcion = () => {     
        try{
            console.log('🔍 [SUSCRIPCIÓN] Iniciando suscripción...');
            console.log('🔍 [SUSCRIPCIÓN] Permiso en este momento:', Notification.permission);
            
            serviceWorker.pushSubscribeUser().then((result) => {      
               console.log('push result', result)          
               alert('Suscripto exitosamente. Podra desuscribirse en cualquier momento.');
               
               setTimeout(()=>this.actualizar(), 500)
                
            }).catch(error => {
                console.error('🔍 [SUSCRIPCIÓN] Error en suscripción:', error);
            }); 
        }catch(err){
            console.error('Error generando suscripcion', err);
        }       
    }

    actualizar = () =>{
        this.props.getLogueado();
        this.setState({justRefresh: !this.state.justRefresh, hasSuscripcionPush:true});
    }

    // Función para mostrar instrucciones específicas
    mostrarInstruccionesMovil = () => {
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isAndroid = /Android/i.test(navigator.userAgent);
        
        let mensaje = '';
        
        if (isIOS) {
            mensaje = `Para iOS:\n1. Ve a Ajustes → Safari\n2. Desplázate hacia abajo y toca "Configuración avanzada"\n3. Ve a "Configuración del sitio web" → "Notificaciones"\n4. Encuentra este sitio y cambia a "Permitir"`;
        } else if (isAndroid) {
            mensaje = `Para Android:\n1. Toca los 3 puntos (⋮) → Configuración\n2. Ve a "Configuración del sitio" → "Notificaciones"\n3. Encuentra esta app y cambia a "Permitir"`;
        } else {
            mensaje = `Para habilitar notificaciones:\n1. Ve a la configuración de tu navegador\n2. Busca "Permisos" o "Configuración del sitio"\n3. Encuentra este sitio web y habilita "Notificaciones"`;
        }
        
        const getAlert = alertConfirm('Notificaciones Bloqueadas',
                `Las notificaciones están bloqueadas.\n\n${mensaje}\n\nDespués de cambiar la configuración, recarga la página.`,
                null,
                'Cerrar',
                this.props.clearAlertConfirm,
                null,
                null,
                true,
                'danger',
                false
            )  
        this.props.enviarAlertConfirm(getAlert);
    }



    render(){
        const {user} = this.props;
        const{justRefresh, hasSuscripcionPush} = this.state;
        return (
            <div className="main-content">
                <Container fluid>
                    <Row className="justify-content-center mt-5 th_cielo">
                        <Col lg={7} sm={12}>
                            <div className="card-components border-left-c">
                                <div className="card-body">
                                <Row>
                                    <Col lg={12} sm={12}>
                                        <span className="material-icons text-white lead">stay_primary_portrait</span> <span className="text-white txt-12">Aplicaciones externas sincronizadas</span>
                                    </Col>
                                    <Col  lg={7} sm={9} className="text-right mt-3">
                                        <Row className="justify-content-center text-center">
                                            <Col xs={12}>
                                                {(user && user.telegramChatId && user.telegramChatId!=='')?<><p className="text-cielo lead font-weight-bold"><span className="material-icons-outlined align-middle">check_circle</span> Telegram activa</p></>:
                                                    <>
                                                        <p className="text-muted lead font-weight-bold"><span className="material-icons-outlined align-middle">phonelink_erase</span> Telegram no activa</p>
                                                        <hr></hr>

                                                        <button className="btns btns-cielo btn-sm" type="button" onClick={()=>this.setState({showTelegram:true})} >
                                                        <i className="fas fa-paper-plane"></i> ¿Comá activarla?
                                                        </button>
                                                    </>
                                                    }
                                            </Col>
                                        </Row>
                                        
                                        {user && (user.username == 'nico' || user.username == 'marianopoliti1983@gmail.com' || user.username == 'Nico' || user.username == 'nicotest' || user.username == 'nicoTest' || user.username == 'politi.marcos@gmail.com') && 
                                        <Row className="justify-content-center text-center mt-3">
                                            <Col xs={12}>
                                                <span className="text-white">Notificaciones del explorador</span>
                                               
                                                {hasSuscripcionPush?
                                                <button className="btns btns-tomate" type="button" onClick={this.desuscribir} >
                                                    <i className="fas fa-paper-plane"></i> Desuscribir notificaciones
                                                </button>
                                                
                                                :
                                                <button className="btns btns-fucsia" type="button" onClick={this.pedirSuscripcion} >
                                                    <i className="fas fa-paper-plane"></i> Suscribir notificaciones
                                                </button>}
                                            </Col>
                                        </Row>}
                                       
                                    </Col>
                                </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                   {(user && !user.esUsuarioExterno)&& <Row className="justify-content-center mt-5">
                        <Col lg={7} sm={12}>
                            <div className="card-components border-left-c">
                            <div className="card-body">
                                <Row>
                            <Col lg={5} sm={3}>
                            <span className="material-icons text-white lead">lock</span> <span className="text-white lead">Credenciales</span>
                            </Col>
                            <Col  lg={7} sm={9} className="text-right">
                            <button className="btns btns-iot" type="button" onClick={()=>this.setState({show:true})} >
                            <span className="material-icons">password</span> Cambiar contraseña 
                            </button>
                            </Col>
                            </Row>
                            </div>
                            </div>
                        </Col>
                    </Row>} 
                    
                    <Row className="justify-content-center mt-5">
                        <Col lg={7} sm={12}>
                            <div className="card-components">
                            <div className="card-body">
                            <Col>
                            <FormDatosUsuario className="bg-iot" accion='actualizar' />
                            </Col>
                            </div>
                            </div>
                        </Col>
                    </Row> 
                </Container>

                {this.state.show && <FormCambiarPassword show={this.state.show} handleClose={()=>this.handleClose()} />} 
                {this.state.showTelegram && <Modal show={this.state.showTelegram} onHide={this.handleClose} backdrop="static"  >
                    <Modal.Header className="bg-cielo text-white" closeButton>
                        <Modal.Title><i className="fas fa-paper-plane"></i> ¿Comó activar Telegram?</Modal.Title>
                    </Modal.Header> 
                    <Modal.Body className="th_uva">
                        <div className="sc-box mt-4">
                            <div className="sc-container sc-timeline">
                            <div className="sc-timeline-item">
                                <i className="bg-gradient-vistas sc-timeline-icon fas fa-download"></i> 
                                <div className="sc-timeline-info">
                                <div className="sc-timeline-details">
                                    <span className="sc-timeline-time">PASO 1</span>
                                </div>
                                <h6 className="sc-timeline-title">Instalar Telegram</h6>
                                </div>
                            </div>
                            <div className="sc-timeline-item sc-actionsheet-trigger">
                                <i className="bg-gradient-vistas sc-timeline-icon fas fa-cog"></i> 
                                <div className="sc-timeline-info">
                                <div className="sc-timeline-details">
                                    <span className="sc-timeline-time">PASO 2</span>
                                </div>
                                <h6 className="sc-timeline-title">Configurar correctamente el número de teléfono en el perfil. Ej: "1133334444" </h6>
                                </div>
                            </div>
                            <div className="sc-timeline-item">
                                <i className="bg-gradient-vistas sc-timeline-icon fas fa-search"></i> 
                                <div className="sc-timeline-info">
                                <div className="sc-timeline-details">
                                    <span className="sc-timeline-time">PASO 3</span>
                                </div>
                                
                                <h6 className="sc-timeline-title">Buscar nuestro usuario. IotechApp_bot</h6>
                                </div>
                            </div>
                            <div className="sc-timeline-item">
                                <i className="bg-gradient-vistas sc-timeline-icon fas fa-envelope"></i> 
                                <div className="sc-timeline-info">
                                <div className="sc-timeline-details">
                                    <span className="sc-timeline-time">PASO 4</span>
                                </div>
                                
                                <h6 className="sc-timeline-title">Enviarle un mensaje "/start"</h6>
                                </div>
                            </div>
                            <div className="sc-timeline-item">
                                <i className="bg-gradient-vistas sc-timeline-icon fas fa-share-alt"></i> 
                                <div className="sc-timeline-info">
                                <div className="sc-timeline-details">
                                    <span className="sc-timeline-time">PASO 5</span>
                                </div>
                                
                                <h6 className="sc-timeline-title"> Compartir tu contacto.</h6>
                                </div>
                            </div>
                            </div>
                        </div>
                    </Modal.Body>                     
                </Modal>} 
            </div>
        );
    }
}

function mapState(state) {   
    const { userData } = state.authentication;
    const user = userData;
    return { user };
}

const actionCreators = {
    getLogueado:userActions.getLogueado,
   enviarAlertConfirm:alertActions.enviarAlertConfirm,
   clearAlertConfirm:alertActions.clearAlertConfirm
}

const connectedMisDatos = connect(mapState, actionCreators)(MisDatos);
export { connectedMisDatos as MisDatos };